import { queryOptions } from '@tanstack/react-query';

import { getAgreementQuery, getAgreementsQuery } from './shared';

export const getAgreementQueryOptions = (id: string) => queryOptions(getAgreementQuery(id));
export const getAgreementsQueryOptions = () => queryOptions(getAgreementsQuery());
